/* ================================================
   SEVITAL — CLEAN GLOBAL CART ENGINE (FINAL VERSION)
================================================ */

console.log("SEVITAL CART ENGINE — CLEAN VERSION LOADED");

document.addEventListener("DOMContentLoaded", () => {
  const drawer        = document.querySelector("[data-cart-drawer]");
  const overlay       = document.querySelector("[data-cart-overlay]");
  const closeBtn      = document.querySelector("[data-cart-close]");
  const toggleButtons = document.querySelectorAll("[data-cart-toggle]");
  const itemsWrap     = document.querySelector("[data-cart-items]");
  const subtotalEl    = document.querySelector("[data-cart-subtotal]");
  const countEls      = document.querySelectorAll("[data-cart-count]");

  const formatMoney = (cents) => (cents / 100).toFixed(2) + " SEK";

  /* --------------------------------------------
     OPEN / CLOSE DRAWER (GLOBAL)
  -------------------------------------------- */
  window.openCartDrawer = function () {
    if (!drawer) {
      console.warn("openCartDrawer called but no [data-cart-drawer] found");
      return;
    }
    drawer.setAttribute("aria-hidden", "false");
    drawer.classList.add("active");
    if (overlay) overlay.classList.add("active");
    document.documentElement.classList.add("no-scroll");
  };

  window.closeCartDrawer = function () {
    if (!drawer) return;
    drawer.setAttribute("aria-hidden", "true");
    drawer.classList.remove("active");
    if (overlay) overlay.classList.remove("active");
    document.documentElement.classList.remove("no-scroll");
  };

  // SAFER LISTENERS (NO CRASH IF ELEMENTS MISSING)
  if (overlay && typeof window.closeCartDrawer === "function") {
    overlay.addEventListener("click", window.closeCartDrawer);
  }
  if (closeBtn && typeof window.closeCartDrawer === "function") {
    closeBtn.addEventListener("click", window.closeCartDrawer);
  }
  if (toggleButtons.length && typeof window.openCartDrawer === "function") {
    toggleButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        window.openCartDrawer();
      });
    });
  }

  /* --------------------------------------------
     FETCH CART
  -------------------------------------------- */
  async function getCart() {
    try {
      const res = await fetch("/cart.js");
      return await res.json();
    } catch (err) {
      console.error("Cart fetch error:", err);
      return { items: [], item_count: 0, total_price: 0 };
    }
  }

  /* --------------------------------------------
     RENDER CART DRAWER
  -------------------------------------------- */
  async function renderCart() {
  const cart = await getCart();

  // Update cart count badges
  countEls.forEach((el) => {
    if (!el) return;
    el.textContent = cart.item_count ?? 0;
  });

  // Subtotal
  if (subtotalEl) {
    subtotalEl.textContent = formatMoney(cart.total_price || 0);
  }

  if (!itemsWrap) return;

  // Empty cart state
  if (!cart.items || cart.items.length === 0) {
    itemsWrap.innerHTML = `
      <div class="cart-drawer__empty">
        <p>Your cart is empty</p>
        <a href="/collections/all" class="btn btn--primary" data-cart-close>
          Continue Shopping
        </a>
      </div>`;
    return;
  }

  // Render line items
  itemsWrap.innerHTML = cart.items
    .map((item) => {
      // Debug log in console to inspect values if needed
      console.log("CART ITEM:", {
        title: item.title,
        quantity: item.quantity,
        price: item.price,
        line_price: item.line_price,
        properties: item.properties,
        selling_plan_allocation: item.selling_plan_allocation,
      });

      return `
      <div class="cart-drawer__line" data-key="${item.key}">
        <div class="cart-drawer__media">
          <img 
            src="${item.image}" 
            width="80" 
            height="80" 
            loading="lazy" 
            alt="${item.product_title || ""}"
          >
        </div>

        <div class="cart-drawer__info">
          <a class="cart-drawer__title" href="${item.url}">
            ${item.title}
          </a>

          ${
            item.properties && item.properties.Pack
              ? `<div>${item.properties.Pack}</div>`
              : ""
          }
          ${
            item.properties && item.properties.BundleDiscount
              ? `<div>Discount: ${item.properties.BundleDiscount}</div>`
              : ""
          }
          ${
            item.selling_plan_allocation
              ? `<div class="cart-drawer__subscription">Subscription</div>`
              : ""
          }

          <div class="cart-drawer__price">
            ${formatMoney(item.line_price || item.price * item.quantity)}
          </div>

          <div class="cart-drawer__qty">
            <button type="button" data-qty-dec>−</button>
            <input data-qty-input type="number" value="${item.quantity}" min="1">
            <button type="button" data-qty-inc>+</button>
          </div>

          <button type="button" data-remove class="cart-drawer__remove">
            Remove
          </button>
        </div>
      </div>
    `;
    })
    .join("");

  bindCartEvents();
}

  /* --------------------------------------------
     HANDLE QTY + REMOVE
  -------------------------------------------- */
  function bindCartEvents() {
    // decrease qty
    document.querySelectorAll("[data-qty-dec]").forEach((btn) =>
      btn.addEventListener("click", (e) => {
        const line = e.target.closest("[data-key]");
        if (!line) return;
        const input = line.querySelector("[data-qty-input]");
        if (!input) return;
        const current = parseInt(input.value, 10) || 1;
        const next = current - 1;
        if (next <= 0) {
          updateLine(line.dataset.key, 0);
        } else {
          updateLine(line.dataset.key, next);
        }
      })
    );

    // increase qty
    document.querySelectorAll("[data-qty-inc]").forEach((btn) =>
      btn.addEventListener("click", (e) => {
        const line = e.target.closest("[data-key]");
        if (!line) return;
        const input = line.querySelector("[data-qty-input]");
        if (!input) return;
        const current = parseInt(input.value, 10) || 1;
        const next = current + 1;
        updateLine(line.dataset.key, next);
      })
    );

    // manual input
    document.querySelectorAll("[data-qty-input]").forEach((input) =>
      input.addEventListener("change", (e) => {
        const line = e.target.closest("[data-key]");
        if (!line) return;
        let val = parseInt(input.value, 10);
        if (isNaN(val) || val < 1) val = 1;
        input.value = val;
        updateLine(line.dataset.key, val);
      })
    );

    // remove
    document.querySelectorAll("[data-remove]").forEach((btn) =>
      btn.addEventListener("click", (e) => {
        const line = e.target.closest("[data-key]");
        if (!line) return;
        updateLine(line.dataset.key, 0);
      })
    );
  }

  /* --------------------------------------------
     UPDATE LINE (USES item.key → Seal/Bundler SAFE)
  -------------------------------------------- */
  async function updateLine(key, qty) {
    try {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      await renderCart();
    } catch (err) {
      console.error("Update error:", err);
    }
  }

  /* --------------------------------------------
     GLOBAL ADD TO CART — ALL FORMS
     - Theme handles normal forms
     - Bundler / Seal forms are marked with data-app-cart="true" and skipped
  -------------------------------------------- */
  document.addEventListener("submit", async (e) => {
    const form = e.target.closest("form[action='/cart/add']");
    if (!form) return;

    // ⛔ Let Bundler / Seal handle their own forms
    if (form.dataset.appCart === "true") {
      return;
    }

    e.preventDefault();

    const data = new FormData(form);

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        body: data,
      });

      if (!res.ok) {
        console.error("Add to cart failed", await res.text());
        alert("Could not add to cart. Please try again.");
        return;
      }

      await renderCart();
      if (window.openCartDrawer) window.openCartDrawer();
    } catch (err) {
      console.error("Add to cart error:", err);
      alert("Could not add to cart. Please try again.");
    }
  });

  // expose render for other scripts
  window.refreshCartDrawer = renderCart;
  window.renderCartDrawer = renderCart;

  // initial load
  renderCart();
});

/* ============================================================
   GLOBAL CART HELPERS (HOMEPAGE + COLLECTIONS BUTTONS)
============================================================ */

window.addToCartAjax = async function (
  variantId,
  quantity = 1,
  properties = {}
) {
  return fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      items: [
        {
          id: parseInt(variantId, 10),
          quantity,
          properties,
        },
      ],
    }),
  });
};

/* ------------------------------------------------------------
   GLOBAL CLICK HANDLER FOR HOMEPAGE + COLLECTIONS BUTTONS
   - Uses .add-to-cart-home (not product-hero)
   - Avoids Bundler / Seal forms
------------------------------------------------------------ */
document.addEventListener("click", async function (e) {
  const btn = e.target.closest(".add-to-cart-home");
  if (!btn) return;

  // If somehow inside a /cart/add form AND it's app-controlled, ignore
  const parentForm = btn.closest("form[action='/cart/add']");
  if (parentForm && parentForm.dataset.appCart === "true") {
    return;
  }

  // Prevent double-click / double-tap spam
  if (btn.dataset.adding === "true") {
    return;
  }
  btn.dataset.adding = "true";

  const variantId = btn.dataset.productId;
  if (!variantId) {
    btn.dataset.adding = "false";
    return;
  }

  // UI feedback
  const textEl = btn.querySelector(".add-to-cart-text");
  const spinner = btn.querySelector(".loading-spinner");
  const added   = btn.querySelector(".added-text");

  if (textEl) textEl.style.display = "none";
  if (spinner) spinner.style.display = "inline-block";
  btn.disabled = true;

  try {
    const res = await window.addToCartAjax(variantId, 1);
    if (!res.ok) throw new Error("Error adding to cart");

    // Success animation
    if (spinner) spinner.style.display = "none";
    if (added)   added.style.display   = "inline";

    // Update cart drawer
    if (window.refreshCartDrawer) await window.refreshCartDrawer();
    if (window.openCartDrawer) window.openCartDrawer();
  } catch (err) {
    console.error("Add to cart failed", err);
    alert("Failed to add to cart. Try again.");
  }

  setTimeout(() => {
    if (textEl) textEl.style.display = "inline";
    if (spinner) spinner.style.display = "none";
    if (added)   added.style.display   = "none";
    btn.disabled = false;
    btn.dataset.adding = "false";
  }, 2000);
});
